// Features switched off by the owner (2026-10-13), hidden behind stubs until they are needed:
//  - cryptoUsdt: USDT (Ethereum mainnet) deposits and withdrawals; tx-proxy refuses them too
//  - metamask: linking a MetaMask wallet (moving property NFTs out of the platform)
export const FEATURES = {
  cryptoUsdt: false,
  metamask: false,
};
